import { Ingredient } from "@/types/ingredient.types";

export const calculateProportionSum = (ingredients: Ingredient[]) =>
    ingredients.reduce((aggregator, ingredient) => (aggregator += ingredient.currentProportion), 0);

export const calculateIngredientAutoAdjustment = (autoAdjustIngredientId: number, ingredients: Ingredient[]) => {
    const currentAutoAdjustIngredientProportion = ingredients.find(
        (ingredient) => ingredient.id === autoAdjustIngredientId
    )?.currentProportion;

    if (currentAutoAdjustIngredientProportion === undefined) {
        console.error("Could not find ingredient to auto-adjust proportion");
        return 0;
    }

    return Math.max(0, currentAutoAdjustIngredientProportion + (100 - calculateProportionSum(ingredients)));
};
